import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-expense-ai-amount',
  templateUrl: './expense-ai-amount.component.html',
  styleUrls: ['./expense-ai-amount.component.scss']
})
export class ExpenseAiAmountComponent {
  @Input() currency: string;
  @Input() amount: number;
  @Input() hasAiData: boolean = false;
  @Input() matches: boolean = false;
  @Input() mismatchReason: string;
  @Input() showNegative: boolean = false;
}
